export default function ContactForm() {
  return (
    <section id="contact" className="py-24 bg-gradient-to-b from-white to-gray-50">
      <div className="max-w-4xl mx-auto px-6">
        <div className="text-center mb-12">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            個別面談お申し込み
          </h2>
          <p className="text-base text-red-600 font-bold">
            ※定員に達し次第、募集を終了いたします
          </p>
        </div>

        <div className="bg-white rounded-xl border-2 border-gray-200 p-10 md:p-16 flex flex-col items-center gap-8 text-center">
          <div className="w-16 h-16 flex items-center justify-center rounded-full bg-amber-50 border-2 border-amber-200">
            <i className="ri-calendar-check-line text-3xl text-amber-500"></i>
          </div>

          <div>
            <div className="inline-flex items-center gap-2 px-4 py-2 bg-green-50 border border-green-200 rounded-full mb-4">
              <i className="ri-check-line text-green-600"></i>
              <span className="text-sm font-bold text-green-700">完全無料</span>
            </div>
            <p className="text-lg md:text-xl font-semibold text-gray-800 mb-2">
              下記ボタンより、申し込みフォームへお進みください
            </p>

          </div>

          <a
            href="https://form.run/@yachinzero"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center justify-center gap-3 w-full sm:w-auto px-12 py-5 bg-gradient-to-r from-amber-500 to-amber-600 text-white rounded-lg text-lg md:text-xl font-bold hover:from-amber-600 hover:to-amber-700 transition-all shadow-xl hover:shadow-2xl transform hover:scale-[1.02] border-2 border-amber-400 cursor-pointer"
          >
            <i className="ri-external-link-line text-xl"></i>
            無料の個別面談に申し込む
          </a>

          <p className="text-xs text-gray-500 leading-relaxed">
            ※個別面談は完全無料です。<br className="hidden md:block" />
            ※お預かりした個人情報は、個別面談のご案内以外の目的では使用いたしません。<br className="hidden md:block" />
            ※無理な勧誘は一切行いませんので、ご安心ください。
          </p>
        </div>
      </div>
    </section>
  );
}
